import { setCloseAnimationStyles } from "./functions/setCloseAnimationStyles";
import { setOpenAnimationStyles } from "./functions/setOpenAnimationStyles";

type Input = {
  canTransition: boolean;
  handleTransitionEnd: (event?: TransitionEvent) => void;
  innerElement: HTMLDivElement;
  isOpened: boolean;
  panelElement: HTMLDivElement;
};

export const setAnimationStyles = (input: Input) => {
  const { isOpened, ...rest } = input;

  if (isOpened) {
    setOpenAnimationStyles({ ...rest });
    return;
  }

  setCloseAnimationStyles({ ...rest });
};
